import { ModuleWithProviders, NgModule } from '@angular/core';
import { IProductNavigation, IProductSideNav } from '../interfaces';
import { ProductNavigationService } from '../services';

@NgModule({})
export class ProductNavigationModule {

	public static root: ModuleWithProviders<ProductNavigationModule>;

	public static service: ProductNavigationService;

	public static register(products: IProductNavigation[]): ModuleWithProviders<ProductNavigationModule>;
	public static register(products: IProductNavigation[], sidenavs: IProductSideNav[]): ModuleWithProviders<ProductNavigationModule>;
	public static register(_products: IProductNavigation[], _sidenavs?: IProductSideNav[]): ModuleWithProviders<ProductNavigationModule> {
		if (!ProductNavigationModule.root) {
			ProductNavigationModule.service = new ProductNavigationService(_products, _sidenavs);
			ProductNavigationModule.root = {
				ngModule: ProductNavigationModule,
				providers: [
					{
						provide: ProductNavigationService,
						useValue: ProductNavigationModule.service
					}
				]
			};
		} else {
			ProductNavigationModule.service.addProductNavigations(..._products);

			if (_sidenavs)
				ProductNavigationModule.service.addProductSideNavs(..._sidenavs);
		}

		return ProductNavigationModule.root;
	}

}
